<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <c-card title="Editar dependencia">
          <dependency-form />
        </c-card>
      </div>
    </div>
  </div>
</template>
<script>
import DependencyForm from "@/components/Forms/DependencyForm.vue";
import CCard from "@/components/CCard.vue";
export default {
  components: {
    DependencyForm,
    CCard,
  },
};
</script>
